import LazyImage from "../common/LazyImage/LazyImage";
import MotionReveal from "../common/MotionReveal/MotionReveal";
import MotionStagger from "../common/Motion/MotionStagger";
import MotionItem from "../common/Motion/MotionItem";
import { homeGlobalPresenceContent } from "../../data/homeData";

function HomeGlobalPresence() {
  const data = homeGlobalPresenceContent;

  return (
    <section className="bg-white py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-stretch">
          <MotionReveal variant="fadeRight" className="h-full">
            <LazyImage
              src={data.image}
              alt="SAC global operational footprint"
              className="h-[280px] w-full rounded-[24px] object-cover shadow-2xl sm:h-[360px] md:rounded-[32px] lg:h-full lg:min-h-[620px]"
            />
          </MotionReveal>

          <MotionReveal variant="fadeLeft">
            <span className="uppercase tracking-[0.3em] text-red-600 text-sm font-semibold">
              {data.eyebrow}
            </span>

            <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 leading-tight">
              {data.title}
              <span className="text-red-500"> {data.titleAccent}</span>
            </h2>

            <p className="mt-6 text-base sm:text-lg text-slate-600 leading-relaxed text-justify">
              {data.intro}
            </p>

            <MotionStagger className="mt-8 space-y-4">
              {data.regions.map((region) => (
                <MotionItem
                  key={region.name}
                  variant="fadeUp"
                  className="rounded-2xl border border-slate-200 bg-slate-50 px-5 py-4 transition-all hover:border-red-200 hover:bg-white hover:shadow-sm"
                >
                  <h3 className="text-base font-bold text-[#041E42]">{region.name}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-600">{region.description}</p>
                </MotionItem>
              ))}
            </MotionStagger>

            {/* <div className="grid grid-cols-3 gap-4 sm:gap-6 mt-10">
              {data.stats.map((stat) => (
                <div key={stat.label} className="text-center sm:text-left">
                  <h3 className="text-2xl sm:text-4xl font-bold text-red-500">{stat.value}</h3>
                  <p className="text-slate-600 text-xs sm:text-sm mt-1">{stat.label}</p>
                </div>
              ))}
            </div> */}
          </MotionReveal>
        </div>
      </div>
    </section>
  );
}

export default HomeGlobalPresence;
